import { useMutation, useQueryCache } from "react-query";
import axios from '../../axiosWrapper'
import { query } from '../../util/config'

export default function useRemoveAdminFromTeam(id) {
  const cache = useQueryCache();
  const team = cache.getQueryData(["teams", id]);
  if (team) team.admins = team && team.admins ? team.admins : [];
  return useMutation(async (admId) => {
    let adminIds = team.admins.map(admin => admin.id)
    if (adminIds.includes(admId)) {
      team.admins = [...team.admins.filter(a => a.id !== admId)]
      const uniqueIds = team.admins.map(item => item.id).filter((value, index, self) => self.indexOf(value) === index)
      return await axios.put(`teams/${id}`, { admins: uniqueIds })
    }
    return -1;
  }, {
    onSuccess: (updated) => {
      if (updated && updated.id) {
        cache.setQueryData(["teams", updated.id], (prev) => {
          prev.admins = team.admins
          return prev
        })
      }
    }
  }, query.initialQuery)
}
